<template lang="pug">
  div(
    :style="styles.wrapper"
  )
    LibraryGrid(
      fullWidth
      v-if="policiesLoaded"
    )
      .view-explanation
        <button class="toggle-cards button__action button__delete" @click="toggleDeleted()">{{showDeleted ? 'View Active Policies' : 'View Deleted Policies'}}</button>
        h1 Policies
        p Policies are a set of rule groups that initiate a &nbsp;
          router-link(
            to="/sequences"
          ) sequence
          | . Each group contains a set of rules and conditions. When a user of the app fulfills all the rules of the policy, the platform will launch the designated sequence and begin delivering &nbsp;
          router-link(
            to="/cards"
          ) action cards.
      section(
        v-for="policy in getPolicies"
        v-if="showDeleted ? policy.deleted : !policy.deleted"
        class="cardWrap"
        @click="setActivePolicy(policy)"
      )
        div(
          :style="styles.cardContainer"
        )
          p(
            :style="styles.cardName"
          ) Policy
          p {{policy.title}}
        i(
          :style="styles.backIcon"
          class="glyphicon glyphicon-chevron-right"
        )
      section(
        class="cardWrap"
        @click="createNewPolicy"
        v-if="!showDeleted"
      )
        div(
          :style="styles.cardContainer"
        )
          p(
            :style="styles.cardName"
          ) Policy
          p Create New Policy
        i(
          :style="styles.backIcon"
          class="glyphicon glyphicon-chevron-right"
        )
    Spinner(
      v-if="!policiesLoaded"
    )
</template>
<script>
import LibraryGrid from '../general/LibraryGrid';
import Services from '../../services/Services';
import Spinner from '../general/Spinner';
import store from '../../store';
export default {
  name: 'policyLibrary',
  components: {
    Spinner,
    LibraryGrid
  },
  computed: {
    getPolicies() {
      return store.getters.getPolicies;
    }
  },
  methods: {
      toggleDeleted(){
          this.showDeleted = !this.showDeleted
      },
    togglePoliciesLoaded() {
      this.policiesLoaded = true;
    },
    setActivePolicy(policy) {
      // Services.setActivePolicy(policy);
      this.$router.push('/policies/' + policy._id);
    },
    createNewPolicy() {
      this.$router.push('/policies/create');
    }
  },
  data() {
    return {
    showDeleted: false,
      policiesLoaded: false,
      blankPolicy: {
        title: '',
        rules: [],
        sequence: null
      },
      styles: {
        wrapper: {
          display: 'flex',
          flexFlow: 'row nowrap',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          height: '100vh',
          // boxSizing: 'border-box',
          // padding: '0 1rem',
          width: '100%'
        },
        cardContainer: {
          display: 'flex',
          flexFlow: 'column nowrap'
        },
        cardPreview: {
          background: 'teal',
          position: 'relative',
          padding: '20'
        },
        cardName: {
          color: '#aaa',
          fontSize: '0.9em',
          marginBottom: '0'
        },
        cardMetadataSection: {
          display: 'flex',
          flexFlow: 'column nowrap',
          padding: '40',
          width: '100%'
        },
        backIcon: {
          margin: 'auto 5px auto auto',
          color: '#aaa'
        }
      }
    };
  },
  mounted() {
    Services.getPolicies(this.togglePoliciesLoaded);
    Services.setActivePolicy(this.blankPolicy);
  }
};
</script>
<style lang="scss" scoped>
.cardWrap {
  background: #fff;
  display: flex;
  border: 1px solid #eee;
  padding: 0 10px;
  box-sizing: border-box;
  flex-flow: row nowrap;
  width: calc(33.33% - 1rem);
  margin: 1rem 0.5rem;
  // margin-left: 0;
  transition: all 0.2s;
  &:hover {
    border: 1px solid #888;
    cursor: pointer;
  }

  &:first-child {
    // margin-left: 1rem;
  }
}
.toggle-cards {

    @media all and (min-width:641px){
        right: 2rem;
        top: 6rem;
        position: absolute;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/views/PolicyLibrary.vue